import React from 'react'
import { FormattedMessage } from 'react-intl'
import CheckboxGroup from 'components/CheckboxGroup'

import messages from './messages'
import styles from './LocationsSection.scss'

type EnrichedBusinessLocationType = {
  originalLocation: string
  count: number
}

export interface ILocationsSection {
  locations: Array<string>
  enrichedBusinessLocations: Array<EnrichedBusinessLocationType>
}

function LocationsSection({ locations = [], enrichedBusinessLocations = [] }: ILocationsSection) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.summary}>
          <div className={styles.title}>
            <FormattedMessage {...messages.locations} />
          </div>
        </h3>
      </header>
      <div className={styles.content}>
        <div className={styles.filters}>
          <CheckboxGroup
            type='regular'
            name='locationFilters'
            options={enrichedBusinessLocations.map(({ originalLocation, count }) => `${originalLocation} (${count})`)}
            selections={[]}
            onChange={option => {}}
          />
        </div>
        <div className={styles.locations}>
          <div className={styles.title}>
            <FormattedMessage
              {...messages.addresses}
              values={{ count: locations ? locations.length : 0 }}
              tagName='span'
            />
          </div>
          {!!locations && locations.length === 1
            ? locations[0]
            : locations
                .filter(element => !!element)
                .map((element, index) => (
                  <li key={index} className={styles.listItem}>
                    {element}
                  </li>
                ))}
        </div>
      </div>
    </div>
  )
}

export default LocationsSection
